exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tabbar_position[data-v-bcfa4e52] {\r\n  position: fixed;\r\n  bottom: 0;\r\n  background: #fff;\n}\r\n", ""]);

// exports
